import { Component, OnInit, ViewChild } from '@angular/core';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community';
import { AgGridActionsRendererComponent } from 'src/app/modules/shared/components/ag-grid-action-renderer/ag-grid-action-renderer.component';
import { AgGridActionsWrapperComponent } from 'src/app/modules/shared/components/ag-grid-actions-wrapper/ag-grid-actions-wrapper.component';
import { AgGridWrapperComponent } from 'src/app/modules/shared/components/ag-grid-wrapper/ag-grid-wrapper.component';
import { AdminHelperService } from '../../services/admin-helper.service';
import { AdminMasterEnum, IAdminMasterTab } from '../../models';
import { AdminService } from '../../services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-ehs-data',
  templateUrl: './ehs-data.component.html',
  styleUrls: ['./ehs-data.component.scss']
})
export class EhsDataComponent implements OnInit {

  // ag-grid 
  public gridOptions: GridOptions = {
    defaultColDef: {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 250,
      filter: true,
      resizable: true,
      autoHeight: true,
      wrapText: true
    },
    suppressContextMenu: false,
    suppressMenuHide: false,
    sideBar: "true",
    rowGroupPanelShow: 'always',
    headerHeight: 40,
    pagination: true,
    paginationPageSize: 25,
    rowSelection: 'multiple',
    suppressCellSelection: true,
    overlayNoRowsTemplate: 'No results found.'
  }
  public columnDefs: (ColDef | ColGroupDef)[] = [];
  public context: any;
  public frameworkComponents: any;
  public ehsData: any = [];
  @ViewChild('grid') grid!: AgGridWrapperComponent;
  //ag-grid
  constructor(private _helperService:AdminHelperService,
    private _adminService : AdminService,
    private _toastr : ToastrService,
    public _decimalPipe: DecimalPipe) { this.frameworkComponents = {
    AgGridActionsWrapperComponent: AgGridActionsWrapperComponent,
    AgGridActionsRendererComponent: AgGridActionsRendererComponent
  };
  this.context = { componentParent: this }; }

  ngOnInit(): void {
    this.fetchEHSdata();
  }

  public onGridReady(params: any) {
    this.grid.autoSizeAll(false);
  }

  public onRowSelect(event:any){
    console.log(event);
    // const selectedRows = event.api.getSelectedRows();
    // this.selectedRows = selectedRows;
  }

  public openMasterPopup(){
    const ehsData:IAdminMasterTab = {
      title : 'EHS', 
      description : 'string',
      tabType : AdminMasterEnum.EHS,
      data : null,
      keyName : "EHS",
      isUpload : true,
      serviceAPI : (payload : any) => this._adminService.uploadEHSdata(payload),
      payload : (data : any) => { return { ehs : data } },
      heads : []
    }
    const result$ = this._helperService.openMasterPopup(ehsData);
    if(result$) {
      result$.subscribe((res : any) => {
        const payload = new FormData();
        payload.append("file",res)
        !!res && ehsData.serviceAPI(payload).subscribe((response) => {
          this._toastr.success(response.message);
          this.fetchEHSdata();
        }, err => {
          this._toastr.error(err.error.message);
        });
      });
    }
  }

  public fetchEHSdata(){
    this._adminService.getEHSdata().subscribe((res:any)=>{
      if(res.data){
        this.ehsData = res.data;
        this.setColumnDefs();
      }else
        this.ehsData = [];
    })
  }

  private setColumnDefs() : void {
    this.columnDefs = [{ headerName: 'Id', field: "id" },{ headerName: 'Vendor Code', field: "vendor_code" }, { headerName: 'Vendor Name', field: "vendor_name" },{ headerName: 'Sum of Net Order Value - INR', field: "sum_of_net_order_value", 
    cellRenderer: (data: any) => {
      if(data.value){
        let sum = this._decimalPipe.transform(data.value, '1.2-2');
        return sum? sum :''
      } else{
        return ''
      }
    }
     }, { headerName: 'Services', field: "services" },{ headerName: 'Vendor Category', field: "vendor_catgory" }, { headerName: 'Category A/C', field: "category_account" },{ headerName: 'Remarks', field: "remarks" }, { headerName: 'EHS Score', field: "ehs_score" },{ headerName: 'Last evaluation date(YYYY-MM-DD)', field: "last_evaluation_date" }, { headerName: 'Evaluation due on(YYYY-MM-DD)', field: "evaluation_due_on" },{ headerName: 'Location', field: "location" },{ headerName: 'EHS Review Comments', field: "review_comments" },{ headerName: 'Team Comments', field: "team_comments" },{ headerName: 'Open PO', field: "open_po" },{ headerName: 'SCM FE comments', field: "scm_fe_comments" },];
  }

}
